import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Cover from './cover'
import {
  getFetchRequest,
  getAssessmentFile
} from '../../../../stores/assessment-file/assessment-file.selectors'
import { fetchAssessmentFile } from '../../../../stores/assessment-file/assessment-file.actions'

import { fetchAssessmentFileWorks } from '../../../../stores/works/works.actions'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = (state, { match }) => {
  const fetchRequest = getFetchRequest(state)
  const assessmentFile = getAssessmentFile(state)
  return {
    id: match.params.assessmentFileId,
    pending: fetchRequest.pending,
    assessmentFile
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: id => {
    dispatch(fetchAssessmentFileWorks(id))
    dispatch(fetchAssessmentFile(id)).catch(e =>
      toast.error(
        'Sorry, we could not find this moderation file. You may not have been invited, or it may have been deleted.'
      )
    )
  }
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Cover)
)
